/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';
import CurrentSubscriptionDisplay from 'app/components/Subscription/CurrentSubscriptionDisplay.jsx';
import AddOnWidget from 'app/components/Subscription/AddOnWidget.jsx';
import AddTweetModal from 'app/components/Subscription/AddTweetModal.jsx';
import SubscriptionPage from '@/shadcn/components/account/SubscriptionPage/SubscriptionPage.tsx';

class LegacyPricing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            add_on_posts_1: 0,
            isEditingPlan: false
        };

        this.getLimit = this.getLimit.bind(this);
        this.setAddOns = this.setAddOns.bind(this);
        this.addPosts = this.addPosts.bind(this);
        this.addOnCancel = this.addOnCancel.bind(this);
        this.subscriptionUpdate = this.subscriptionUpdate.bind(this);

    }

    componentDidMount() {

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Upgrade Legacy'}
                    }
                }
            });
        }

        if (!_.isEmpty(this.props.plans.current) && this.props.plans.current.addOns !== undefined && this.props.plans.current.addOns.add_on_posts_1 !== undefined) {
            this.setState({
                add_on_posts_1: this.props.plans.current.addOns.add_on_posts_1.qty
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.add_on_posts_1) {
            if (this.props.plans.current.addOns &&
                this.props.plans.current.addOns.add_on_posts_1 !== undefined &&
                this.props.plans.current.addOns.add_on_posts_1.qty !== this.state.add_on_posts_1 &&
                !this.state.isEditingPlan) {
                this.setState({
                    isEditingPlan: true
                });
            }
        }

    }

    setAddOns(quantity) {

        this.setState({
            add_on_posts_1: quantity
        });

    }

    getLimit(limit) {

        return (limit === -1 || limit === "-1") ? "Unlimited" : limit;

    }

    addPosts() {
        let constants = this.props.app.config.constants,
            nextQuantity = this.state.add_on_posts_1,
            subscriptionInfo = {
                subscription: this.props.plans.current,
                addOns: {
                    add_on_posts_1: nextQuantity
                }
            },
            addOns = [
                {
                    addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                    quantity: nextQuantity
                }
            ],
            newLimits = {},
            confirmation = null,
            currentQuantity = 0;

        if (_.isObject(this.props.plans.current.addOns.add_on_posts_1)) {
            currentQuantity = this.props.plans.current.addOns.add_on_posts_1.qty;
        };

        newLimits = this.props.calculateAddOns(addOns);

        confirmation = (
            <ConfirmationModal
                {...this.props}
                confirmationType="addonchange"
                confirmationAction={this.subscriptionUpdate}
                subscription={subscriptionInfo}
                newLimits={newLimits}
                addOnType={[constants.SUBSCRIPTION_ADDON_POSTS_1]}
                planLevel={this.props.plans.current.planLevel}
                planTerm={this.props.plans.current.planTerm}
                onConfirmationCancel={() => {
                    this.setState({
                        add_on_posts_1: currentQuantity,
                        isEditingPlan: false
                    });
                }}/>
        );

        if (gtag) {
            let promoData = this.props.getPersistedData('gaPromo');

            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: (this.state.add_on_posts_1 > currentQuantity) ? 'Purchase Add-On Posts' : 'Remove Add-On Posts',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: (this.state.add_on_posts_1 > currentQuantity) ? 'Purchase Add-On Posts' : 'Remove Add-On Posts',
                    event_data: {
                        quantity: this.state.add_on_posts_1
                    }
                });
            }

        }

        this.props.closeOtherModals(confirmation);
    }

    subscriptionUpdate() {

        this.props.onAddOnUpdate({
            add_on_posts_1: this.state.add_on_posts_1
        });

    }

    addOnCancel(type) {
        let previousValue = 0;

        if (this.props.plans.current?.addOns[type]?.qty) {
            previousValue = this.props.plans.current?.addOns[type]?.qty
        }

        let state = Object.assign({}, this.state);

        state[type] = previousValue;

        this.setState(state);

    }

    render() {
        let constants = this.props.app.config.constants,
            annualIncentive = null,
            termLabel = '',
            planLabel = '',
            planPriceLabel = '',
            limits = this.props.calculateAddOns(),
            nextLimits = {},
            savingsPct = 0,
            savingsTotal = 0,
            currentLimits = this.props.calculateAddOns(),
            addOnError = '',
            error = '';

        if (_.isEmpty(this.props.user.plan) || _.isEmpty(this.props.planDetails) || this.props.app.loading.SUB_FETCH_DETAIL) {
            return (
                <Loading />
            );
        }

        nextLimits = this.props.calculateAddOns([{
            addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
            quantity: this.state.add_on_posts_1
        }]);

        let annualPrice = this.props.plans.details[this.props.plans.current.planLevel]?.price[constants.SUBSCRIPTION_TERM_ANNUAL],
            monthlyPrice = this.props.plans.details[this.props.plans.current.planLevel]?.price[constants.SUBSCRIPTION_TERM_MONTHLY],
            monthlyAnnual = monthlyPrice * 12;

        savingsTotal = (monthlyAnnual - annualPrice).toFixed(2);
        savingsPct = ((savingsTotal / monthlyAnnual) * 100).toFixed(0);

        planLabel = 'dlvr.it ' + this.props.plans.details[this.props.user.detail.pubLevel]?.label;

        planPriceLabel = <FormattedNumber value={nextLimits.price} style="currency" currency="USD"/>;

        let subscriptionPause = null;
        if (this.props.user.plan.pauseStart && this.props.user.plan.pauseEnd) {
            subscriptionPause = {
                start: new Date(this.props.user.plan.pauseStart),
                end: new Date(this.props.user.plan.pauseEnd),
                cycles: this.props.user.plan.pauseCycles
            }
        }

        return (
            <div className="subscription-info">
                <div className="tw-root">
                    <SubscriptionPage
                        constants={this.props.app.config.constants}
                        plan={this.props.user.plan}
                        currentLimits={currentLimits}
                        nextLimits={limits}
                        planDetails={this.props.plans.details[this.props.user.detail.pubLevel]}
                        currentAddOns={{
                            add_on_posts_1: this.state.add_on_posts_1,
                        }}
                        planName={planLabel}
                        planPrice={planPriceLabel}
                        postLimit={"Unlimited"}
                        onClickXPosts={(qty) => {
                            this.setState({
                                add_on_posts_1: qty
                            })
                        }}
                        onConfirmAddOn={this.addPosts}
                        onCancelAddOn={this.addOnCancel}
                        cancelPlan={this.props.cancelPlan}
                        restartPlan={this.props.restartPlan}
                        savingsPct={savingsPct}
                        savingsTotal={savingsTotal}
                        activeCoupons={[]}
                        subscriptionPause={subscriptionPause}
                        comparePlans={(e) => {
                            e.preventDefault();
                            this.props.router.navigate("/account/subscription/compare")
                        }}
                        addOnError={addOnError}
                        setRequestParams={this.props.setRequestParams}
                        promoClick={this.props.promoClick}
                        changeTerm={this.props.changeTerm}
                        resumeSubscription={() => {
                            this.props.pauseSubscription({
                                duration: 0
                            });
                        }}
                    />
                </div>
            </div>
        );
    }

};

LegacyPricing.displayName = "LegacyPricing";

LegacyPricing.propTypes = {
    currentSubscription: PropTypes.object,
    planDetails: PropTypes.object,
    onAddOnUpdate: PropTypes.func,
    subscriptionUpdate: PropTypes.func,
    errors: PropTypes.object
};

LegacyPricing.defaultProps = {
    currentSubscription: {},
    planDetails: {},
    onAddOnUpdate: null,
    subscriptionUpdate: null,
    errors: null
};

export default LegacyPricing;
